// extracted by mini-css-extract-plugin
module.exports = {"back-button-header":"back-button-header__37jwp","back-button-text":"back-button-text__fGaPV"};